import React from "react";
import styles from "./HomeUs.module.scss";
import { Link } from "react-router-dom";
import routes from "../../../constants/routes";
import Image1 from "../../../assets/hero_us_1.jpg";
import Image2 from "../../../assets/hero_us_2.jpg";

const HomeUs = (props) => {
  return (
    <div className={`section ${styles.section}`}>
      <div className={`wrapper ${styles.wrapper}`}>
        <div className={styles.images}>
          <img src={Image1} alt="" />
          <img src={Image2} alt="" />
        </div>
        <div className={styles.text}>
          <h2 className="section_subtitle">¿Quiénes somos?</h2>
          <p className="section_text">
            Realizamos Diagnóstico de fallas y Service profesional en Motos.
            Utilizando los mejores equipos y herramientas. Entregando evidencia
            de todo el trabajo realizado mediante imágenes, videos e informes.
            Rápida resolución y con garantía.
          </p>

          <Link to={routes.mentorships.path}>Conocer más</Link>
        </div>
      </div>
    </div>
  );
};

export default HomeUs;
